import { render, staticRenderFns } from "./checkUpResult.vue?vue&type=template&id=ebad28be"
import script from "./checkUpResult.vue?vue&type=script&lang=js"
export * from "./checkUpResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebad28be')) {
      api.createRecord('ebad28be', component.options)
    } else {
      api.reload('ebad28be', component.options)
    }
    module.hot.accept("./checkUpResult.vue?vue&type=template&id=ebad28be", function () {
      api.rerender('ebad28be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkUpResult.vue"
export default component.exports